export const reOrgConstructionMaterialConstants = {
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_REORG_CONSTRUCTION_MATERIAL_FAILURE',
		CLEAR   : 'GET_PAGED_AUDIT_REORG_CONSTRUCTION_MATERIAL_CLEAR'
	},
	GetPaged: {
		SUCCESS : 'GET_PAGED_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		REQUEST : 'GET_PAGED_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		FAILURE : 'GET_PAGED_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	GetExampleFile: {
		SUCCESS : 'GET_EXAMPLE_FILE_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		REQUEST : 'GET_EXAMPLE_FILE_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		FAILURE : 'GET_EXAMPLE_FILE_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	GetDuplicateNamesFile: {
		SUCCESS : 'GET_DUPLICATE_NAMES_FILE_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		REQUEST : 'GET_DUPLICATE_NAMES_FILE_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		FAILURE : 'GET_DUPLICATE_NAMES_FILE_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	RemoveDuplicateNames: {
		SUCCESS : 'REMOVE_DUPLICATE_NAMES_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		REQUEST : 'REMOVE_DUPLICATE_NAMES_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		FAILURE : 'REMOVE_DUPLICATE_NAMES_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	GetReOrgList: {
		SUCCESS : 'GET_LIST_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		REQUEST : 'GET_LIST_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		FAILURE : 'GET_LIST_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'CREATE_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		FAILURE : 'CREATE_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	CreateFromFile: {
		REQUEST : 'CREATE_REORG_CONSTRUCTION_MATERIAL_FROM_FILE_REQUEST',
		SUCCESS : 'CREATE_REORG_CONSTRUCTION_MATERIAL_FROM_FILE_SUCCESS',
		FAILURE : 'CREATE_REORG_CONSTRUCTION_MATERIAL_FROM_FILE_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'DELETE_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		FAILURE : 'DELETE_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	DeleteSelected: {
		REQUEST : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		FAILURE : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	DeleteByFilter: {
		REQUEST : 'DELETE_BY_FILTER_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'DELETE_BY_FILTER_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		FAILURE : 'DELETE_BY_FILTER_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		FAILURE : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_REORG_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'RESTORE_REORG_CONSTRUCTION_MATERIAL_SUCCESS',
		FAILURE : 'RESTORE_REORG_CONSTRUCTION_MATERIAL_FAILURE'
	},
	CLEAR: 'CLEAR_REORG_CONSTRUCTION_MATERIAL'
}